import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import './index.css';

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: '',
            field: '',
            showAlert: false,
            reRender: 1
        };

        this.handleChange = this.handleChange.bind(this);
        this.filteredData = this.props.sellers;
    }

    handleChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleClick = (evt) => {
        const props = this.props;
        this.setState({ reRender: 2 })
        props.buttonData.map((val, key) => {
            const elemValue = JSON.parse(evt.target.value)
            if (val.id == elemValue.value) {
                val.toggler(val.id)
            }
        })
    }

    componentDidMount = () => {
        this.props.filter &&
            this.setState({
                field: this.props.columns["0"].key
            })
    }



    filterList = (evt) => {
        var searchTerm = evt.target.value;
        this.filteredData = this.props.sellers.filter(
            (data) => {
                if (data[this.state.field] !== null) {

                    return (data[this.state.field].toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
                }
            }
        )
        this.props.view(this.filteredData, searchTerm);
    }

    reRenderButton(showHide) {
        this.setState({
            reRender: !showHide
        })
    }

    componentWillReceiveProps(newProps, prevProps) {
        if (newProps.disableState !== undefined) {
            if (newProps.disableState !== prevProps.disableState) {
                this.setState({
                    reRender: newProps.disableState
                })
            }
        }
    }


    renderButtons() {
        const { buttonData } = this.props;

        return buttonData.map((val, index) => {
            const button = (
                <button
                    key={val.id}
                    value={JSON.stringify({ key: index, value: val.id })}
                    data-key={val.id}
                    className={
                        val.disabled === 'disabled' && !val.doNotDisable
                            ? "btn btn-red btn-sm text-uppercase disableButton"
                            : "btn btn-red btn-sm text-uppercase"
                    }
                    onClick={this.handleClick}
                    style={{ margin: '2px', fontSize: '10px' }}
                >
                    {val.heading}
                </button>
            );

            // Add a line break after the 4th button
            if (index === 4) {
                return (
                    <React.Fragment key={`fragment-${val.id}`}>
                        {button}
                        <div style={{ width: '100%' }}></div>
                    </React.Fragment>
                );
            }

            return button;
        });
    }







    render() {
        const { externalLinks, secondColumn, widthClass } = this.props;
        const columns = this.props.columns !== undefined ? this.props.columns : '';



        return <div className="bg-gray container">
            <div className="row p-2">

                <div className={` ${widthClass} pt-2 pb-2`}>
                    <div className="row align-items-center" style={{ height: '100%' }}>
                        <div className="col-2 col-md-1 col-lg-1" style={{
                            width: 40,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <i className="fas fa-cog text-white" />
                        </div>
                        <div className="border-white border-left pr-0 col-9 col-md-9 col-lg-9" style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}>

                        {this.state.reRender === 2 || this.state.reRender === 1 ? this.renderButtons() : null}
                        </div>
                    </div>
                </div>
                <div className="col-md-6 pt-2 pb-2">

                    {
                        this.props.csv === undefined ?
                            secondColumn === true ?
                                <div className="row align-items-center" style={{ height: '100%' }}>
                                    <div className="col-2 col-md-1 col-lg-1" style={{
                                        width: 40,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <i className="fas fa-external-link-alt text-white"></i>
                                    </div>
                                    <div className="border-white border-left pr-0 col-9 col-md-9 col-lg-9" style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}>
                                        {

                                            externalLinks.map((val, key) => (
                                                <Link key={val.id} style={{ margin: 2 }} className={val.disabled === true
                                                    ? "btn btn-red btn-sm text-uppercase disableButton"
                                                    : "btn btn-red btn-sm text-uppercase"} to={{ pathname: val.disabled === true ? `${this.props.match.url}` : `${this.props.match.url}/${val.link}`, state: this.props.sellerState, currentLink: val.link }} >
                                                    <p key={key} style={{ color: 'white', margin: '2px', fontSize: '10px' }}>{val.heading}</p>
                                                </Link>
                                            ))
                                        }
                                    </div>
                                </div>
                                :

                                this.props.filter === "true" &&
                                <div className="row align-items-center">
                                    <div className="col-2 col-md-1 col-lg-1" style={{
                                        width: 40,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <i className="fas fa-search text-white" />
                                    </div>
                                    <div className="border-white border-left col-10 col-md-11 col-lg-11" style={{ borderTopLeftRadius: 2, borderBottomLeftRadius: 2 }}>
                                        <div className="d-flex flex-row justify-content-start participantSearch" >
                                            <div style={{ position: 'relative' }} className="col-md-6">
                                                <i className="fas fa-sort-down text-white filterIcon"></i>
                                                <Input
                                                    defaultValue="state"
                                                    type="select" name="field"
                                                    bsSize="sm" className="filterOption text-white border-radius-zero"
                                                    onChange={this.handleChange}
                                                >
                                                    {columns.map(function (column, index) {
                                                        if (column.filter === undefined) {
                                                            return <option className="bg-gray" value={column.key} key={index}>{column.name}</option>;
                                                        }
                                                    })}
                                                </Input>
                                            </div>
                                            <div className="input-group input-group-sm col-md-6">
                                                <input type="text" className="form-control border-radius-zero" aria-label="search" placeholder="Search..." aria-describedby="search" name="searchTerm"
                                                    onChange={this.filterList}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                            null
                    }
                </div>

            </div>
        </div>;
    }
}

function mapStateToProps(state) {

    return {
        state
    };

}

const connectedPage = connect(mapStateToProps)(Settings);
export default withRouter(connectedPage); 


// WEBPACK FOOTER //
// ./src/_components/common/SettingsHead/index.js